import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { BalanceReportList } from './BalanceReportList';

export const balanceReportResource: ResourceProps = {
  name: Resources.BalanceReport,
  list: BalanceReportList,
  create: <></>,
  edit: <></>,
  show: <></>,
};
